import {
    createDescriptionObjectForList,
    createListFromObject,
} from "../../Utilities/Types/listUtilities";

export const ORDER_TYPE = {
    All: -1,
    Order: 0,
    SpecialOrderRequest: 1,
};

export const ORDER_TYPE_LIST = createListFromObject(ORDER_TYPE);

export const ORDER_PREPARATION_STATUS = {
    RequestPhysicalCopy: createDescriptionObjectForList("2", "Request Physical Copy"),
    PhysicalCopyReceived: createDescriptionObjectForList("3", "Physical Copy Received"),
};

export const PLACE_THE_ORDER_STATUS = {
    ...ORDER_PREPARATION_STATUS,
    GeneratePurchaseOrder: createDescriptionObjectForList("4", "Generate Purchase Order"),
    OrderSourcedCompleted: createDescriptionObjectForList("5", "Order Sourced Completed"),
    ProduceInternally: createDescriptionObjectForList("6", "Produce Internally"),
    OrderSentToVendor: createDescriptionObjectForList("7", "Order Sent To Vendor"),
};
export const PLACE_THE_ORDER_STATUS_LIST = createListFromObject(PLACE_THE_ORDER_STATUS);

export const ORDER_FULFILLMENT_STATUS = {
    PartialOrderReceived: createDescriptionObjectForList("8", "Partial Order Received"),
    FullOrderReceived: createDescriptionObjectForList("9", "Full Order Received"),
};

export const ORDER_STATUS = {
    OrderReceivedFromPatron: createDescriptionObjectForList("1", "Order Received From Patron"),
    ...PLACE_THE_ORDER_STATUS,
    ...ORDER_FULFILLMENT_STATUS,
    AddToCatalogInventory: createDescriptionObjectForList("10", "Add To Catalog Inventory"),
    PrintBarcode: createDescriptionObjectForList("11", "Print Barcode"),
    PrintMailingLabel: createDescriptionObjectForList("12", "Print Mailing Label"),
    ReadyToMail: createDescriptionObjectForList("13", "Ready To Mail"),
    Mailed: createDescriptionObjectForList("14", "Mailed"),
    OrderComplete: createDescriptionObjectForList("15", "Order Complete"),
    OrderCancelledByPatron: createDescriptionObjectForList("16", "Order Cancelled By Patron"),
    OrderCancelledByFimc: createDescriptionObjectForList("17", "Order Cancelled By Fimc"),
    ShelveVolumes: createDescriptionObjectForList("18", "Shelve Volumes"),
    VolumesShelved: createDescriptionObjectForList("19", "Volumes Shelved"),
};
export const ORDER_STATUS_LIST = createListFromObject(ORDER_STATUS);
